import type { TopDownCollectSpec } from "./kinds/top-down-collect/spec";

export type PrimitiveKind =
  | "keyboard-touch-input"
  | "bounded-top-down-movement"
  | "circle-collision"
  | "seeded-collectibles"
  | "seeded-hazards"
  | "collect-all-objective"
  | "timed-lifecycle";

export interface PrimitiveSystem {
  readonly kind: PrimitiveKind;
  readonly parameters: Readonly<Record<string, string | number>>;
}

export interface PrimitivePlan {
  readonly version: 1;
  readonly target: "browser-2d";
  readonly systems: readonly PrimitiveSystem[];
}

/** Maps a validated top-down-collect spec to reusable, non-executable game systems. */
export function primitivePlanForSpec(spec: TopDownCollectSpec): PrimitivePlan {
  return {
    version: 1,
    target: "browser-2d",
    systems: [
      { kind: "keyboard-touch-input", parameters: { schema: "arrows-wasd-pointer-v1" } },
      { kind: "bounded-top-down-movement", parameters: { width: spec.world.width, height: spec.world.height, speed: spec.player.speed } },
      { kind: "circle-collision", parameters: { playerRadius: 18, collectibleRadius: 11, hazardRadius: 18 } },
      { kind: "seeded-collectibles", parameters: { seed: spec.seed, count: spec.world.goalCollectibles } },
      { kind: "seeded-hazards", parameters: { seed: spec.seed, count: spec.world.hazards } },
      { kind: "collect-all-objective", parameters: { goal: spec.world.goalCollectibles } },
      { kind: "timed-lifecycle", parameters: { seconds: spec.world.timeLimitSeconds } },
    ],
  };
}
